import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box, makeStyles } from '@popmenu/common-ui';
import { DishCategoryPage } from '../DishCategoryPage';
import { DishFeedPage } from '../DishFeedPage';
import { DishListIndexPage } from '../DishListIndexPage';
import { DishListPage } from '../DishListPage';

const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 auto',
    maxWidth: `calc(1200px + ${theme.spacing(8)}px)`,
    minWidth: `calc(256px + ${theme.spacing(8)}px)`,
    padding: theme.spacing(4),
  },
}));

export const PageContent = () => {
  const classes = useStyles();

  return (
    <Box component="section">
      <Box className={classes.container}>
        <Switch>
          <Route path="/lists/:dishListSlug">
            <DishListPage />
          </Route>
          <Route path="/lists">
            <DishListIndexPage />
          </Route>
          <Route path="/places/:placeSlug/categories/:categorySlug">
            <DishCategoryPage />
          </Route>
          <Route path="/places/:placeSlug">
            <DishFeedPage />
          </Route>
          <Route path="/">
            <DishFeedPage />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};
